import moment from 'moment';

export default class Util {
    loadCss(url) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = url;
        document.getElementsByTagName("head")[0].appendChild(link);
    }
    hasValue(v) {
        var result = true;
        if (v == null) result = false;
        else if (v == "") result = false;
        return result;
    }
    esVacio(v) {
        return !this.hasValue(v);
    }
    getString(v) {
        var result = v;
        if (this.esVacio(result)) result = "";
        result = "" + result;
        return result;
    }
    /*
    * Devuelve la cadena con el tamaño especificado. Si es mayor la corta y si es menor la rellena con espacios
    */
    getStringSize(cadena, size) {
        return this.pad(this.getString(cadena), size);
    }
    /*
    * Devuelve la cadena con el tamaño especificado. Si es mayor la corta y si es menor la rellena con espacios
    */
    getStringSizeZerosLeft(cadena, size) {
        return this.pad(this.getString(cadena), size, "0", this.STR_PAD_LEFT);
    }
    /*
    * Devuelve la cadena con el tamaño especificado. Si es mayor la corta y si es menor la rellena con espacios
    */
    getStringSizeZerosRight(cadena, size) {
        return this.pad(this.getString(cadena), size, "0", this.STR_PAD_RIGHT);
    }
    STR_PAD_LEFT= 1;
    STR_PAD_RIGHT= 2;
    STR_PAD_BOTH= 3;
    /*
    * Dada una cadena y el tamaño maximo de la misma devuelve una cadena con tamaño fijo con el texto a la derecha, centrado o a la izquierda
    */
    pad(str, len, pad, dir) {
        if (typeof (len) == "undefined") { var len = 0; }
        if (typeof (pad) == "undefined") { var pad = ' '; }
        if (typeof (dir) == "undefined") { var dir = this.STR_PAD_RIGHT; }

        if (str.length > len) str = str.substring(0, len);

        if (len + 1 >= str.length) {

            switch (dir) {

                case this.STR_PAD_LEFT:
                    str = Array(len + 1 - str.length).join(pad) + str;
                    break;

                case this.STR_PAD_BOTH:
                    var right = Math.ceil((padlen = len - str.length) / 2);
                    var left = padlen - right;
                    str = Array(left + 1).join(pad) + str + Array(right + 1).join(pad);
                    break;

                default:
                    str = str + Array(len + 1 - str.length).join(pad);
                    break;

            } // switch

        }
        return str;
    }
    isEmptyObj(obj) {
        return !Object.keys(obj).length > 0;
    }
    perteneceLista(valor, lista) {
        var res = false;
        var pos = ("," + lista + ",").indexOf("," + valor + ",");
        if (pos != -1) {
            res = true;
        }
        return res;
    }
    //Dado un objeto recorre sus propiedades y establece los valores del modelo Backbone "model". No introduce los campos id ni los internos
    copyObjToModel(obj, model) {
        var me=this;
        //model.set("País",jsonAttributes["País"]);
        _.each(obj, function(value, key, obj) {
            if (util.perteneceLista(key,"__metadata,id,Id,CreatedById,Created,CreatedBy,Modified,ModifiedBy,ModifiedById,Owshiddenversion,Version,Attachments,Path")) {

            } else {
                me.log(key);
                model.set(key,value);
            }
        });
    }
    intNoNull(i) {
        if (i == null) i = 0;
        return i;
    }
    /* Dado una cadena devuelve el entero (o 0) que significa */
    str2int(valor) {
        var res = 0;
        if (valor === null) valor = "0";
        try {
            res = parseInt(valor);
            if (isNaN(res)) {
                res = 0;
            }
        }
        catch (e) {
            res = 0;
        }
        return res;
    }
    /*
    ** Dado un numero en español con decimales devuelve el float asociado. Por ejemplo 4,4 devuelve float(4.4)
    */
    str2float(valor) {
        var res = 0.0;
        if (valor == null) {
            valor = "0";
        }
        valor = this.getString(valor);
        try {
            valor = valor.replace(",", ".");
            res = parseFloat(valor);
            if (isNaN(res)) {
                res = 0.0;
            }
        }
        catch (e) { }

        return res;
    }
    /**
     * Devuelve la diferencia entre las fechas en número de segundos Las fechas pueden ser numeros enteros (o strings con la fecha en formato AAAAMMDD
     **/
    calculateDiffFechas(fechaDown, fechaUp) {
        var momentUp = moment(fechaUp, "YYYYMMDDHHmmss");
        var momentDown = moment(fechaDown, "YYYYMMDDHHmmss");
        var diff = momentUp.diff(momentDown, 'seconds');
        return diff;
    }
    calculateDiffFechasWithUnit(fechaDown, fechaUp) {
        var momentUp = moment(fechaUp, "YYYYMMDDHHmmss");
        var momentDown = moment(fechaDown, "YYYYMMDDHHmmss");
        var diff = momentUp.diff(momentDown, 'minutes');
        var result = diff + " min";
        if (diff > 60) {
            diff = momentUp.diff(momentDown, 'hours');
            result = diff + " hours";
            if (diff > 48) {
                diff = momentUp.diff(momentDown, 'days');
                result = diff + " days";
            }
        }
        return result;
    }
    dosDecimales(valor) {
        var result = Math.round(valor * 100) / 100;
        return result;
    }
    //Dada una fecha tipo YYYYMMDDHHmmss y un entero con el offset tipo -2 ajusta la fecha acorde
    ajustaOffset(fecha, offset) {
        var result = fecha;
        var seconds = 3600 * offset;
        var dFecha = moment(fecha, "YYYYMMDDHHmmss");
        dFecha.add("seconds", seconds);
        result = dFecha.format("YYYYMMDDHHmmss");
        return result;
    }
    //Dada una fecha tipo moment() y un entero con el offset tipo -2 ajusta la fecha acorde
    ajustaOffsetMoment(fecha, offset) {
        var result = fecha;
        var seconds = 3600 * offset;
        var dFecha = fecha;
        dFecha.add("seconds", seconds);
        return dFecha;
    }
    parseJsonDate(jsonDateString) {
        return new Date(moment(jsonDateString));
    }
    jsondate2datetimeExcel(jsondate) {
        var dFecha = moment(jsondate);
        var result = dFecha.format("DD/MM/YYYY H:mm");
        return result;
    }
    bbdd2str(bbdddatetime) {
        var result = "";
        if (this.hasValue(bbdddatetime)) {
            var dFecha = moment(bbdddatetime, "YYYYMMDDHHmmss");
            result = dFecha.format("DD/MM/YYYY");
        }
        return result;
    }
    str2bbdd(bbdddatetime) {
        var result = "";
        if (this.hasValue(bbdddatetime)) {
            var dFecha = moment(bbdddatetime, "DD/MM/YYYY");
            result = dFecha.format("YYYYMMDD");
        }
        return result;
    }
    humanizeDateBbdd(bbdddate) {
        var now=moment();
        var mFecha = moment(bbdddate, "YYYYMMDD");
        var result;
        if (mFecha.year()==now.year()) {
            result= mFecha.format("D MMM");
        } else {
            result = mFecha.format("D MMM YYYY");
        }
        return result;
    }
    bbdd2strtime(bbdddatetime) {
        var dFecha = moment(bbdddatetime, "YYYYMMDDHHmmss");
        var result = dFecha.format("YYYY-MM-DD HH:mm:ss");
        return result;
    }
    datetime2str(datetime) {
        var dFecha = datetime;
        var result = "";
        if (dFecha != null) {
            result = moment(dFecha).format("YYYY-MM-DD HH:mm:ss");
        }
        return result;
    }
    date2str(datetime) {
        var dFecha = datetime;
        var result = "";
        if (dFecha != null) {
            result = moment(dFecha).format("YYYY-MM-DD");
        }
        return result;
    }
    getDateHoy() {
        var result = "";
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //Enero es 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }

        result = "" + yyyy + mm + dd;
        return result;
    }
    sizeOfObject(obj) {
        var size = 0, key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] != null) size++;
            }
        }
        return size;
    }
    //Formatea un double con x decimales
    formatDouble(d,numDecimales) {
        var num = new Number(d);
        result = num.toFixed(numDecimales);
        result = result.replace('.',',');
        return result;
    }
    //Devuelve la base URL donde está la aplicación. Por ejemplo https://www.easywebmonitor.com:4433/
    getUrlBase(req) {
        var result = req.protocol + "://" + req.host + ":" + options.currentHttpServerPort;
        //var result="https://www.easywebmonitor.net:4443/";
        return result;
    }
    trim(str) {
        var result = str.replace(/^\s+|\s+$/g, '');
        return result;
    }
    hasSubstringInString(substring, str) {
        var result = false;
        if (str.indexOf(substring) != -1) {
            result = true;
        } else {
            if (str.toLowerCase().indexOf(substring.toLowerCase()) != -1) {
                result = true;
            }
        }
        return result;
    }
    startsWith(cadena, s) {
        if (cadena.indexOf(s) == 0) return true;
        return false;
    }
    endsWith(cadena, str) {
        return cadena.slice(-str.length) == str;
    }
    getRequest(req) {
        var result = req.query;
        if (util.isEmptyObj(result)) {
            result = req.body;
        }
        return result;
    }
    LFToCRLFutil(cadena) {
        var result = cadena.replace(/\r?\n/g, "\r\n");
        return result;
    }
    /* Separa la cadena por el delimitador y coge el elemento n*/
    getDelim(cadena, delim, num) {
        var res = "";
        try {
            var v = cadena.split(delim);
            res = v[num];
        }
        catch (e) { }
        return res;
    }
    left(cadena, size) {
        var result = "";
        if (size > 0) {
            if (strlen(cadena) >= size) {
                result = cadena.substring(0, size);
            }
        }

        return result;
    }
    /* Devuelve el numero con la longitud deseada rellenando con 0's por la izquierda*/
    nCifras(numero, cifras) {
        var result = numero + "";
        while (result.length < cifras) {
            result = "0" + result;
        }
        return result;
    }
    htmlEncode(value) {
        return this.htmlspecialchars(value);
    }
    attrEncode(value) {
        return this.htmlspecialchars(value);
    }
    htmlspecialchars(string, quote_style, charset, double_encode) {
        //       discuss at: http://phpjs.org/functions/htmlspecialchars/
        //      original by: Mirek Slugen
        //      improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        //      bugfixed by: Nathan
        //      bugfixed by: Arno
        //      bugfixed by: Brett Zamir (http://brett-zamir.me)
        //      bugfixed by: Brett Zamir (http://brett-zamir.me)
        //       revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        //         input by: Ratheous
        //         input by: Mailfaker (http://www.weedem.fr/)
        //         input by: felix
        // reimplemented by: Brett Zamir (http://brett-zamir.me)
        //             note: charset argument not supported
        //        example 1: htmlspecialchars("<a href='test'>Test</a>", 'ENT_QUOTES');
        //        returns 1: '&lt;a href=&#039;test&#039;&gt;Test&lt;/a&gt;'
        //        example 2: htmlspecialchars("ab\"c'd", ['ENT_NOQUOTES', 'ENT_QUOTES']);
        //        returns 2: 'ab"c&#039;d'
        //        example 3: htmlspecialchars('my "&entity;" is still here', null, null, false);
        //        returns 3: 'my &quot;&entity;&quot; is still here'
        if (string == null) string = "";
        var optTemp = 0,
            i = 0,
            noquotes = false;
        if (typeof quote_style === 'undefined' || quote_style === null) {
            quote_style = 2;
        }
        string = string.toString();
        if (double_encode !== false) { // Put this first to avoid double-encoding
            string = string.replace(/&/g, '&amp;');
        }
        string = string.replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');

        var OPTS = {
            'ENT_NOQUOTES': 0,
            'ENT_HTML_QUOTE_SINGLE': 1,
            'ENT_HTML_QUOTE_DOUBLE': 2,
            'ENT_COMPAT': 2,
            'ENT_QUOTES': 3,
            'ENT_IGNORE': 4
        };
        if (quote_style === 0) {
            noquotes = true;
        }
        if (typeof quote_style !== 'number') { // Allow for a single string or an array of string flags
            quote_style = [].concat(quote_style);
            for (i = 0; i < quote_style.length; i++) {
                // Resolve string input to bitwise e.g. 'ENT_IGNORE' becomes 4
                if (OPTS[quote_style[i]] === 0) {
                    noquotes = true;
                } else if (OPTS[quote_style[i]]) {
                    optTemp = optTemp | OPTS[quote_style[i]];
                }
            }
            quote_style = optTemp;
        }
        if (quote_style & OPTS.ENT_HTML_QUOTE_SINGLE) {
            string = string.replace(/'/g, '&#039;');
        }
        if (!noquotes) {
            string = string.replace(/"/g, '&quot;');
        }

        return string;
    }

    dec2hex(d) {
        return d.toString(16);
    }
    hex2dec(h) {
        return parseInt(h, 16);
    }

    /**
     * Dado un elemento y un array, añade el item si no existe ya. Acepta objetos json con igualdad exacta entre campos
     * @param item
     * @param collection
     */
    addIfNotExist(item, collection) {
        var length = collection.length;
        var found = false;

        for (var i = 0; i < length; i++) {
            if (this.jsonObjEquals(collection[i],item)) {
                found = true;
            }
        }

        if (!found) {
            collection.push(item);
        }
    }

    showWaitDialog() {
        window.parent.eval("window.waitDialog = SP.UI.ModalDialog.showWaitScreenWithNoClose(SP.Res.dialogLoading15)");
    }

    closeWaitDialog() {
        if (window.waitDialog != null) {
            window.waitDialog.close();
        }
    }

    notifyId= '';
    showSmallWaitDialog() {
        var me = this;
        me.notifyId = SP.UI.Notify.addNotification('<img src="/_layouts/images/loadingcirclests16.gif" style="vertical-align: top;"/> Working on it...', true);
    }

    closeSmallWaitDialog() {
        var me = this;
        SP.UI.Notify.removeNotification(me.notifyId);
        me.notifyId = '';
    }

    statusId= '';
    AddStatus(title, message, color) {
        var me = this;
        me.statusId = SP.UI.Status.addStatus(title, message);
        SP.UI.Status.setStatusPriColor(me.statusId, color);
    }

    AddMaintenaceStatus() {
        var me = this;
        me.AddStatus("Maintenance:", "During this day we are making improvements in SharePoint. Sorry for the inconvenience.", "yellow");
    }

    RemoveLastStatus() {
        var me = this;
        SP.UI.Status.removeStatus(me.statusId);
        me.statusId = '';
    }

    RemoveAllStatus() {
        SP.UI.Status.removeAllStatus(true);
    }
    /**
     * not so simple check for object equality
     */
    jsonObjEquals(a, b) {
        return this.check(a, b) && this.check(b, a);
    }
    check(a, b) {
        for (var attr in a) {
            if (a.hasOwnProperty(attr) && b.hasOwnProperty(attr)) {
                if (a[attr] != b[attr]) {
                    if (a[attr] !== undefined && a[attr] !==null) {
                        switch (a[attr].constructor) {
                            case Object:
                                return equal(a[attr], b[attr]);
                            case Function:
                                if (a[attr].toString() != b[attr].toString()) {
                                    return false;
                                }
                                break;
                            default:
                                return false;
                        }
                    } else {
                        return false;
                    }
                }
            } else {
                return false;
            }
        }
        return true;
    }
    /**
     * Logea información de la clase
     */
    log(m) {
        logger.log(m);
    }

    //Funcion para parametrizar la función template de underscore para aceptar en las plantillas <? ?> y <?= ?>
    templateFunction(stringTemplate, model) {
        console.log(model);
        _.templateSettings.variable = "model";
        var templateFunction = _.template(stringTemplate);
        var template = templateFunction(model);
        return template;
    }

}


